import CryptoJS from 'crypto-js'

export const KEY1 = 'ipttVOkVqwE5z64e'
export const IV1 = '3718000045084617'

const HEX_CIPHER_RE = /^[0-9a-f]+$/i

/** 解密 hex 密文 */
export function decrypt(str: string, keyStr: string = KEY1, ivStr: string = IV1): string {
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)
  const encryptedHexStr = CryptoJS.enc.Hex.parse(str)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypted = CryptoJS.AES.decrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

/** 加密为 hex 密文 */
export function encrypt(str: string, keyStr: string = KEY1, ivStr: string = IV1): string {
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)
  const srcs = CryptoJS.enc.Utf8.parse(str)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.ciphertext.toString()
}

/**
 * hex 密文尝试解密，失败或结果为空则返回原字符串
 */
export function tryDecryptHex(str: string, keyStr: string = KEY1, ivStr: string = IV1): string {
  if (!str) return ''
  const trimmed = str.trim()
  const isHexCipher =
    trimmed.length >= 32 && trimmed.length % 2 === 0 && HEX_CIPHER_RE.test(trimmed)

  if (!isHexCipher) {
    logDecryptDebug({ inputLen: trimmed.length, isHexCipher: false, reason: '非 hex 密文，原样返回' })
    return trimmed
  }

  try {
    const plain = decrypt(trimmed, keyStr, ivStr)
    const result = plain || trimmed
    logDecryptDebug({
      inputLen: trimmed.length,
      isHexCipher: true,
      plainLen: plain.length,
      changed: result !== trimmed,
      reason: plain ? 'AES 解密成功' : 'AES 解密结果为空，回退为原 hx_pass',
    })
    return result
  } catch (e) {
    logDecryptDebug({
      inputLen: trimmed.length,
      isHexCipher: true,
      changed: false,
      reason: 'AES 解密异常，回退为原 hx_pass',
      error: e,
    })
    return trimmed
  }
}

function logDecryptDebug(info: Record<string, unknown>) {
  if (process.env.NODE_ENV === 'production') return
  console.log('[aesCrypto] tryDecryptHex', info)
}
